export const SKUS_GET = '@SKUS_GET'
export const SKUS_GET_SUCCESS = '@SKUS_GET_SUCCESS'
export const SKUS_GET_FAILURE = '@SKUS_GET_FAILURE'

export const SKU_SELECT = '@SKU_SELECT'

export default {
  SKUS_GET,
  SKUS_GET_SUCCESS,
  SKUS_GET_FAILURE,
  SKU_SELECT
}
